__turbopack_context__.v({
  "className": "roboto_condensed_97d13570-module__Kj-FKa__className",
});
